/* ms-menu.js — contenido del menu movil de modosmile, formato SNOW.
   Monta dentro del panel del menu, sin tocar snippets/header-drawer.liquid:
     · arriba: la X y el logo de la cabecera (clonado)
     · en medio: las entradas del menu, que ya las pone el tema
     · abajo: el buscador y "Mi cuenta", clonando los botones de la cabecera
   Se clonan los nodos del propio tema para no duplicar logica: al pulsar,
   se cierra el panel y se dispara el boton original.
   Todo lo visual va en ms-snow-4.css, bloque K.
   2026-09-02 */
(function () {
  'use strict';

  function montar() {
    var det = document.querySelector('details.menu-drawer-container');
    if (!det) return;
    var panel = det.querySelector('.menu-drawer');
    if (!panel || panel.dataset.msMenu === 'ok') return;

    /* ---- fila superior: X + logo ---- */
    var cerrar = panel.querySelector('.close-button');
    if (!panel.querySelector('.ms-menu-top')) {
      var top = document.createElement('div');
      top.className = 'ms-menu-top';
      var logo = document.querySelector('.header__row--top .header-logo');
      if (logo) {
        var copia = logo.cloneNode(true);
        copia.removeAttribute('style');
        copia.setAttribute('tabindex', '-1');
        top.appendChild(copia);
      }
      panel.insertBefore(top, panel.firstChild);
      if (cerrar) top.appendChild(cerrar);
    }

    /* ---- pie: buscador y cuenta ---- */
    var util = panel.querySelector('.menu-drawer__utility-links');
    if (util && !util.querySelector('.ms-menu-buscar')) {
      var origenBuscar = document.querySelector('.header__row--top .search-modal__button');
      if (origenBuscar) {
        var lupa = origenBuscar.querySelector('.svg-wrapper');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ms-menu-buscar';
        b.setAttribute('aria-label', 'Buscar');
        b.innerHTML = (lupa ? lupa.innerHTML : '') + '<span>Buscar</span>';
        b.addEventListener('click', function () {
          det.open = false;
          origenBuscar.click();
        });
        util.appendChild(b);
      }
      var origenCuenta = document.querySelector('.header__row--top .account-button');
      if (origenCuenta) {
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'ms-menu-cuenta';
        a.textContent = 'Mi cuenta';
        a.addEventListener('click', function () {
          det.open = false;
          origenCuenta.click();
        });
        util.appendChild(a);
      }
    }

    panel.dataset.msMenu = 'ok';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
  /* El tema vuelve a pintar la cabecera despues de cargar y se lleva por
     delante lo montado, asi que se remonta justo antes de abrir. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.menu-drawer-container > summary')) montar();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.menu-drawer-container > summary')) montar();
  }, true);
  /* el editor de temas vuelve a pintar secciones: remontar */
  document.addEventListener('shopify:section:load', montar);
  /* red de seguridad por si la cabecera se hidrata tarde */
  setTimeout(montar, 400);
  setTimeout(montar, 1500);
})();
